import React from 'react'

const Analytics: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Analytics Dashboard</h3>
        <p className="text-gray-600">Advanced analytics functionality coming soon...</p>
      </div>
    </div>
  )
}

export default Analytics
